import { verticalScale } from '@utils/normalize';
import { Platform, StyleSheet } from 'react-native';

export const getTabBarStyle = () => ({
  height: verticalScale(Platform.OS === 'web' ? 70 : 60),
  borderTopLeftRadius: 20,
  borderTopRightRadius: 20,
  paddingBottom: 0,
});

const styles = StyleSheet.create({});

export default styles;
